import { attendanceRecordDateKey } from "./attendanceTimeFormat";
import { lateMinutesFromRow } from "./lateHours";

const COVERING_PERMIT_STATUSES = new Set([
  "pending",
  "gm_pending",
  "in_progress",
  "approved",
]);

function isPermitLikeRequest(request) {
  if (!request) return false;
  return (
    request._source === "permit" ||
    request.category === "permit" ||
    request.type === "إذن" ||
    request.type === "إذن تعويضي"
  );
}

function permitRequestDateIso(request) {
  const raw = request?.startDate || request?.permitDate || "";
  return String(raw).slice(0, 10);
}

/** Dates that already have an open or approved hour-permit. */
export function permitCoveredDateSet(requests = []) {
  const covered = new Set();
  for (const request of requests) {
    if (!isPermitLikeRequest(request)) continue;
    if (!COVERING_PERMIT_STATUSES.has(String(request.status || "").toLowerCase())) {
      continue;
    }
    const dateIso = permitRequestDateIso(request);
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateIso)) covered.add(dateIso);
  }
  return covered;
}

/**
 * Late punch days suitable for hour-permit suggestions.
 * Newest first. Skips days already covered by an open/approved permit.
 */
export function listUncoveredLateDays(records = [], existingRequests = []) {
  const covered = permitCoveredDateSet(existingRequests);
  const byDate = new Map();

  for (const record of Array.isArray(records) ? records : []) {
    const dateIso = attendanceRecordDateKey(record?.date);
    if (!dateIso || covered.has(dateIso)) continue;
    const lateMinutes = lateMinutesFromRow(record);
    if (!(lateMinutes > 0)) continue;
    const prev = byDate.get(dateIso);
    if (!prev || lateMinutes > prev.lateMinutes) {
      byDate.set(dateIso, {
        date: dateIso,
        lateMinutes,
        kind: "LATE",
        label: "تأخير",
      });
    }
  }

  return [...byDate.values()].sort((a, b) => b.date.localeCompare(a.date));
}

export function findLateDayHint(lateDays, dateIso) {
  if (!dateIso) return null;
  return (lateDays || []).find((day) => day.date === dateIso) || null;
}

export function formatLateDayChipLabel(day) {
  if (!day?.date) return "";
  const [, month, dayOfMonth] = day.date.split("-");
  const minutes = Number(day.lateMinutes) || 0;
  const minsLabel =
    minutes >= 60
      ? `${Math.floor(minutes / 60)}س ${minutes % 60}د`
      : `${minutes}د`;
  return `${Number(dayOfMonth)}/${Number(month)} · ${minsLabel}`;
}

/** Prefer newest uncovered late day; otherwise today. */
export function defaultPermitDateIso(lateDays, todayIso) {
  const first = Array.isArray(lateDays) && lateDays.length ? lateDays[0].date : "";
  if (first) return first;
  return todayIso || "";
}
